import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { AppState } from 'redux/config/store'
import { programEditingActions } from './ProgramEditingActions'
import { REPORTED_USAGE_INITIAL_STATE } from './ProgramEditingSlice'

export const REPORTED_USAGE_MERCHANTS = [
  { id: 'uber', label: 'Uber' },
  { id: 'waymo', label: 'Waymo' },
  { id: 'ridepanda', label: 'Ridepanda' },
  { id: 'lyft', label: 'Lyft' },
  { id: 'citi_bike', label: 'Citi Bike' },
  { id: 'capital_bikeshare', label: 'Capital Bikeshare' },
]

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

const Option = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
`

const ReportedUsageProgramEditing = () => {
  const dispatch = useDispatch()
  const merchants =
    useSelector((state: AppState) => state.programEditing.reportedUsage)
      ?.merchants || REPORTED_USAGE_INITIAL_STATE.merchants

  const toggle = (id: string) => {
    const next = merchants.includes(id)
      ? merchants.filter((merchant) => merchant !== id)
      : [...merchants, id]
    dispatch(programEditingActions.changeReportedUsageMerchants(next))
  }

  return (
    <List>
      <Text variant='body1' color={palette.text.secondary}>
        Choose the merchants whose files you will upload. This program does not
        create a balance.
      </Text>
      {REPORTED_USAGE_MERCHANTS.map((merchant) => (
        <Option key={merchant.id}>
          <input
            type='checkbox'
            checked={merchants.includes(merchant.id)}
            onChange={() => toggle(merchant.id)}
          />
          <Text variant='body1'>{merchant.label}</Text>
        </Option>
      ))}
    </List>
  )
}

export default React.memo(ReportedUsageProgramEditing)
